module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAAAAXNSR0IArs4c6QAAAUVJREFUOE+lkT1LA1EQRc+81comaBe0sbBIJ2Ih/gQLEbHQNDa7SyoR/Rd2Iri7GMFWCEQQEStLOy1EEEsRAn4sKGqx7Bt9QiQJCUGc7l3u4d43I3RMpVIZz/P8FBgD7kVkLo7ju1abNB9hGM6o6hEwBKSquikiW8Aw8GGMWYqi6Nz5JQiCjW/TGjDiBFUNjDGXcRzfhGFYstZOikjivMCziOw46A24AAaBKaDWWRlYFJFrl6iq0w76BJaBUWC9C/Ajqeo28CQie79QkiT1XkBT932/3AYBZyIyb601nbCIKFBX1YU2yBhzZa29BWyXRM8YM5Hn+ez/66VpelIoFEqtKZ7nPUZR9NDzT13qubvUkiQp94SKxeJxo9Fwa/+dLMteq9XqS0/oryt/Bw6MMYf97qSqK6paFt/3d0VkFRjoBwEZsP8FWaWcPswa7C4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/ddgl.png
// module id = SuZk
// module chunks = 3